module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-08.2c91d317.png";